import React, {useEffect, useState} from "react";

import {Row} from "antd";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import {capitalize} from "utils/helpers/strings";

import {COLORS} from "../../style/colors";
import Chip from "../Chip";
import Space from "../Space";
import ChevronLeft from "../SVG/ChevronLeft";
import ChevronRight from "../SVG/ChevronRight";
import "./styles.scss";

/**
 * Function to generate days for given week. Note the 'given' week is calculated based on `currentDate` + `week` (weeks)
 * @param currentDate 'current' date to base the week calculation on
 * @param week week incrementer. Number to weeks to add to given (calculated) week
 * @return {(moment.Moment|moment.Moment)[]} array of days for given week.
 */
const getWeekDays = ({currentDate = moment(), week = 0} = {}) => {
	const baseDate = week !== 0 ? moment(currentDate).add(week * 7, 'days') : moment(currentDate);

	const startWeekDate = baseDate.isoWeekday() > 1 ? moment(baseDate).subtract(baseDate.isoWeekday() - 1, 'days') : baseDate;
	return [1, 2, 3, 4, 5, 6, 7].map((_item, _idx) => _idx === 0 ? moment(startWeekDate) : moment(startWeekDate).add(_idx, 'days'));
}

const Calendar = ({onSelectedDate, onWeekChange, availableDays}) => {
	const [days, setDays] = useState([]);
	const [selected, setSelected] = useState();
	const [week, setWeek] = useState(0);
	const handleNav = (factor) => {
		setWeek((_week) => (_week + factor >= 0 ? _week + factor : 0));
	};

	useEffect(() => {
		const currentDate = moment();
		const data = getWeekDays({currentDate: currentDate, week: week});
		const startDate = moment.max(currentDate, moment(data[0])).format("YYYY-MM-DD");
		const endDate = moment(data[data.length - 1]).format("YYYY-MM-DD");
		setDays(data);
		onWeekChange({startDate, endDate});
	}, [week]);

	return (
			<div className="menu-container">
				<div className={"spaced-row"}>
					<p>{capitalize(moment().add(week, "weeks").format("MMMM YYYY"))}</p>
					<Row>
						<div
								className={`${week !== 0 && "control"}`}
								onClick={() => handleNav(-1)}>
							<ChevronLeft
									color={week === 0 ? COLORS.ONYX_MEDIUM : COLORS.ONYX_BLACK}
							/>
						</div>
						<Space w={32} />
						<div className={"control"} onClick={() => handleNav(1)}>
							<ChevronRight />
						</div>
					</Row>
				</div>
				<div className="nav-items fade-in-image ">
					{days.map((el) => (
							<Chip
									key={el.format()}
									text={moment(el).format("ddd D").toUpperCase()}
									selected={selected === el}
									disabled={!availableDays.includes(el.format("YYYY-MM-DD"))}
									onClick={() => {
										setSelected(el);
										onSelectedDate(el.format("YYYY-MM-DD"));
									}}
									animate={true}
									className={"nav-item"}
							/>
					))}
				</div>
			</div>
	);
};

Calendar.propTypes = {
	onSelectedDate: PropTypes.func.isRequired,
	onWeekChange: PropTypes.func.isRequired,
	availableDays: PropTypes.array,
};

Calendar.defaultProps = {
	onSelectedDate: () => {
	},
	onWeekChange: () => {
	},
	availableDays: [],
};

export default Calendar;
